﻿// be carefull all placeholders must be define in German and english.
// it is not created by passolo
export const lng: object = {
  phGlobal_OpenTime: "Öffnungszeiten",
  phGlobal_Pickup_openTime: "Abholzeiten",
  phGlobal_Delivery_openTime: "Lieferzeiten",
  phGlobal_InHouse_openTime: "Bestellzeiten",
  phGlobal_Return: "Zurück",
  phGlobal_Continue: "Weiter",
  phGlobal_Sum: "Summe",
  phGlobal_Discount: "Rabatt",
  phGlobal_Total: "Total",
  phGlobal_Deposit: "Pfand",
  phGlobal_DeliveryFee: "Liefergebühr",

  phGender_None: " ",
  phGender_Woman: "Weiblich",
  phGender_Man: "Männlich",
  phGender_Divers: "Divers",

  phOfflineIndicator_NoConnection: "Keine Verbindung",
  phOfflineIndicator_BackOnline: "Wieder Online",

  phUser_Credit: "Guthaben",
  phUser_Discount: "Rabatt",
  phUser_InvitationAmount: "Einladungsbetrag",

  phEmptyTab_Title: "Entschuldigung!",
  phEmptyTab_Content: "Hier gibt es zur Zeit leider nichts zu sehen. Bitte schauen Sie bald wieder vorbei.",

  phEmptyPage_Title: "Entschuldigung",
  phEmptyPage_Message: "Hier gibt es zur Zeit leider nichts zu sehen. Schauen Sie bald wieder vorbei und kontrollieren Sie bitte Ihre Filtereinstellungen, damit Sie alle für sich interessanten Inhalte angezeigt bekommen.",

  phEmpty_UserLike_Page_Title: "Noch keine Likes?",
  phEmpty_UserLike_Page_Content: "Hier finden Sie alle Inhalte, welche Sie in Ihrer App mit einem 'Like' (Herz) gekennzeichnet haben, so dass Sie sie jederzeit schnell wiederfinden. Probieren Sie es gleich aus!",

  phErrorMessage_Title: "Entschuldigung...",
  phErrorMessage_Text: "Leider konnten wir Ihre Anfrage nicht verarbeiten.<br>Bitte versuchen Sie es später erneut.",
  phErrorMessage_Text_Checkout: "Der Bestellvorgang konnte nicht durchgeführt werden.<br>Bitte versuchen Sie es zu einem späteren Zeitpunkt noch einmal.",
  phErrorMessage_Text_ResetBasket: "Bei der Verarbeitung des Warenkorbes ist leider ein technisches Problem aufgetreten.<br>Wir haben den Fehler bereits korrigiert und bitten Sie, Ihre Bestellung erneut aufzugeben.<br>Vielen Dank für Ihr Verständnis.",
  phErrorMessage_Button: "Ok",

  phDeliverAddressNotDestination_Title: "Entschuldigung...",
  phDeliverAddressNotDestination_Zip_Text: "Die Postleitzahl stimmt nicht mit der zuvor gewählten Lieferadresse \"{zip}\" überein.",
  phDeliverAddressNotDestination_ZipAndCity_Text: "Die Adresse stimmt nicht mit der zuvor gewählten Lieferadresse \"{zip}, {city}\" überein.",

  phLogin_Title: "Anmeldung",
  phLogin_PlaceholderEMail: "E-Mail",
  phLogin_PlaceholderPassword: "Passwort",
  phLogin_ForgotPassword: "Passwort vergessen?",
  phLogin_LogIn: "Login",
  phLogin_NotAMember: "Noch nicht registriert?",
  phLogin_Message: "Bitte prüfen Sie Ihre Eingaben:",
  phLogin_MessageErrorLogin_UnknownReason: "Der Login konnte leider nicht durchführt werden, bitte probieren Sie es später noch einmal.",
  phLogin_MessageErrorLogin_NoEmailGiven: "Bitte geben Sie Ihre E-Mail ein.",
  phLogin_MessageErrorLogin_NoPasswordGiven: "Bitte geben Sie Ihr Passwort ein.",
  phLogin_MessageErrorAuth_InvalidEmail: "Die E-Mail ist ungültig.",
  phLogin_MessageErrorAuth_UserDisabled: "Eine Anmeldung ist zur Zeit nicht möglich.",
  phLogin_MessageErrorAuth_UserNotFound: "Die Zugangsdaten sind uns leider nicht bekannt.",
  phLogin_MessageErrorAuth_WrongPassword: "Die Zugangsdaten sind uns leider nicht bekannt.",
  phLogin_PasswordResetEmailSend: "Wir haben Ihnen eine E-Mail zum Zurücksetzen Ihres Passwortes an <email> geschickt.",

  phMainNav_SideMenuHeader: "Menü",
  phMainNav_AboutUs: "Über uns",
  phMainNav_More: "Mehr",
  phMainNav_Home: "Start",
  phMainNav_Paymentoptions: "Zahlungsarten",
  phMainNav_CopyRight: "Alle Rechte vorbehalten",

  phRatingDialog_SendRate: "Absenden",
  phRatingDialog_Characters_Available: "Verbleibende Zeichen",
  phRatingDialog_Validation_Message: "Sie müssen zuerst die Sterne überprüfen",

  phFilterLayer_Title: "Standort auswählen",
  phFilterLayer_Description: "Filtern Sie weitere Standorte, um Ihnen vorübergehend zusätzliche Informationen anzeigen zu lassen. Unter Standorte können Sie dauerhaft \"liken\".",
  phFilterLayer_Filter: "Filtern",

  phLoginDialog_Login: "Anmelden",
  phLoginDialog_Register: "Jetzt registrieren",

  phLanguageDialog_Title: "Sprache wählen",
  phLanguageDialog_lang_de: "Deutsch",
  phLanguageDialog_lang_en: "Englisch",

  phLocation_TabName_LocationList: "Liste",
  phLocation_TabName_Map: "Karte",
  phLocation_Search_Location: "Standort suchen",

  phLocationDetail_Route: "Ihr Weg zu uns",
  phLocationDetail_Reservation: "Reservierung",
  phLocationDetail_Info_Title: "Adresse und Kontakt",
  phLocationDetail_TabName_Overview: "Übersicht",
  phLocationDetail_TabName_Order: "Bestellung",
  phLocationDetail_PlsChooseService_TEXT: "Bitte wählen Sie aus, wie Sie bei uns bestellen möchten.",
  phLocationDetail_DeviatingOpeningHours: "Abweichende Öffnungszeiten",

  phEvent_TabName_Upcomming: "Aktuell",
  phEvent_TabName_Expired: "Vergangen",

  phEventDetail_Date: "Datum: ",
  phEventDetail_Time: "Uhrzeit: ",
  phEventDetail_From: "Von: ",
  phEventDetail_To: "Bis: ",
  phEventDetail_Location: "Teilnehmende Standorte:",

  phSnackBarMessages: {
    successfullyExecuted: "Erfolgreich ausgeführt",
    unkownLocation: "Standort kann nicht ermittelt werden",
    failed: "Fehlgeschlagen",
    locationNotFound: "Keine Standorte gefunden",
    UpdateFailed: "Aktualisierung fehlgeschlagen",
    deviceOffline: "Ihr Gerät ist offline!",
    deviceOnline: "Ihr Gerät ist online!",
    unsupported: "Ihr Gerät wird nicht unterstützt!",
    scanAgain: "Erneut scannen",
    copiedToClipboard: "In die Zwischenablage kopiert",
  },

  phCounter_UnitNames: {
    Days: "Tage",
    Hours: "Stunden",
    Minutes: "Minuten",
    Seconds: "Sekunden"
  },

  phUserLike_ContentType: {
    News: "News",
    Coupon: "Coupons",
    Event: "Events",
    Location: "Standorte",
    Aktion: "Aktion",
    Menu: "Speisekarte",
    Bonussystem: "Bonusaktionen"
  },

  phRegistration_Title: "Willkommen",
  phRegistr_Tab_Title: "Registrieren Sie sich jetzt kostenlos um viele weitere Vorteile zu genießen.",
  phRegistration_TabName_Register: "Registrieren",
  phRegistration_TabName_Login: "Anmelden",
  phRegistration_LoginTab_ForgetPassword: "Passwort vergessen?",
  phRegistration_RegisterTab_Registerbutton: "Registrieren",
  phRegistration_LoginTab_LoginButton: "Anmelden",
  phRegisteration_Validate_Email: "Die E-Mail ist ungültig",
  phRegisteration_Validate_Password: "Ihr Passwort muss aus 8 Stellen, mindestens einem Buchstaben und einer Zahl bestehen.",
  phRegisteration_ForgetPassword_Message: "Wir haben Ihnen eine E-Mail zugeschickt, mit der Sie Ihr Passwort zurücksetzen können. Sollten Sie keine E-Mail erhalten haben, überprüfen Sie bitte Ihren Spam-Ordner oder klicken Sie auf \"Erneut anfordern\"",
  phRegistration_ForgetPassword_RequestAgain: "Erneut anfordern",
  phRegistration_CheckPrivacy_Error: "Bitte bestätigen Sie unsere rechtlichen Texte",
  phRegistration_Email_PlaceHolder: "E-Mail",
  phRegistration_Password_PlaceHolder: "Passwort",

  phRegister_Failed_message: "Die E-Mail <email> ist bereits registert. Bitte melden Sie sich direkt über die Anmelden-Seite an.",
  phLogin_Failed_message: "Ihr Benutzername oder das Passwort ist falsch.",

  phLoginActivation_Title: "Willkommen",
  phLogin_Tab_Title: "Sie sind bereits registriert? Super!<phloginTitleBreak>Melden Sie sich hier mit Ihren Zugangsdaten an und genießen Sie sofort viele weitere Vorteile.",
  phLoginActivation_TitleMessage: "Gleich geschafft!",
  phLoginActivation_ResetPassword: "Aktivierungsmail erneut senden",
  phLoginActivation_Continue: "Weiter",
  phLoginActivation_Login_Title: "Anmeldung",
  phLoginActivation_ForgetPassword: "Passwort vergessen?",
  phLoginActivation_MainMessage: "Bitte bestätigen Sie Ihre Registrierung, die wir an <email> geschickt haben",
  phLoginActivation_Failed_Message: "Die Registrierung mit der E-Mail <email> wurde noch nicht bestätigt. Bitte prüfen Sie Ihren Posteingang.",

  phForgetPassword_Title: "Passwort vergessen?",
  phForgetPassword_Message: "Bitte geben Sie Ihre E-Mail ein, damit wir Ihr Passwort zurücksetzen können.",
  phForgetPassword_ResetPassword: "Passwort zurücksetzen",
  phForgetPassword_ValidationMessage: "Entschuldigung! Das hat nicht geklappt, bitte überprüfen Sie Ihre Eingabe.",
  phForgetPassword_Email_PlaceHolder: "E-Mail",

  phRegistrationData_Title: "Willkommen",
  phRegistrationData_Label_Name: "Ihr Vorname",
  phRegistrationData_Name_PlaceHolder: "Ihr Vorname",
  phRegistrationData_Location_Select: "Wählen Sie Ihre Lieblingsstandorte aus",
  phRegistrationData_Location_Button: "Standorte auswählen",
  phRegistrationData_SelectedLocation_Button: "Standort ausgewählt",
  phRegistrationData_MultipleSelectedLocation_Button: "Standorte ausgewählt",
  phRegistrationData_Register_Button: "Registrieren",
  phRegistrationData_Location_Validation_Error: "Bitte wählen Sie mindestens einen Ort aus",
  phRegistrationData_Name_Validation_Error: "Der Name darf nicht leer sein.",

  phLocationDialog_ConfirmButton: "Bestätigen",
  phLocationDialog_Title: "Standort wählen",
  phLocationDialog_Description: "Bitte wählen Sie Ihre bevorzugten Standorte aus, so dass Sie nur die für sich relevanten Informationen angezeigt bekommen. Ihre Auswahl können Sie jederzeit im Bereich der Standorte anpassen.",

  phUserProfile_MyProfile: "Mein Profil",
  phUserProfile_Account: "Mein Konto",
  phUserProfile_Order: "Meine Bestellungen",
  phUserProfile_BillingInfo: "Rechnungsinformation",
  phUserProfile_Delivery_Address: "Meine Lieferadressen",
  phUserProfile_User_Addresses: "Meine Adressen",
  phUserProfile_BonusPunkte: "Meine Bonuspunkte",
  phUserProfile_Webgutschein: "Mein Webgutschein",
  phUserProfile_MyLike: "Meine Likes",
  phUserProfile_Feedback: "Feedback",
  phUserProfile_MyAccount_Description: "Bearbeiten Sie Ihren Namen, Geschlecht und Geburtstag.",
  phUserProfile_Order_Description: "Hier können Sie Ihre Bestellungen einsehen.",
  phUserProfile_MyAddress_Description: "Bearbeiten Sie hier Ihre Rechnungs- und Lieferadressen.",
  phUserProfile_PasswordChange_Description: "Sie möchten Ihr Passwort ändern? Kein Problem.",
  phUserProfile_WebGutschein_Description: "Hier können Sie Ihren Gutscheincode einsehen oder einen Code generieren.",
  phUserProfile_MyLike_Description: "Finde Sie schnell Ihre gelikten Inhalte wieder.",
  phUserProfile_Feedback_Description: "Sie möchten uns Feedback geben? Vielen Dank!",
  phUserProfile_BonusPoint_Description: "Hier können Sie den aktuellen Stand Ihrer Bonuspunkte einsehen.",
  phUserProfile_Tags_Subtext: "Hier können Sie Ihre Vorlieben hinterlegen.",

  phUserProfileDetail_Header: "Meine Einstellungen",
  phUserProfileDetail_PlaceHolder_fName: "Vorname",
  phUserProfileDetail_PlaceHolder_Name: "Nachname",
  phUserProfileDetail_PlaceHolder_Email: "E-Mail",
  phUserProfileDetail_PlaceHolder_Birthday: "Geburtstag",
  phUserProfileDetail_PlaceHolder_Gender: "Geschlecht",
  phUserProfileDetail_PlaceHolder_PostalCode: "Postleitzahl",
  phUserProfileDetail_Label_ChangePassword: "Passwort ändern",
  phUserProfileDetail_Label_Logout: "Abmelden",
  phUserProfileDetail_Option_Title: "Einstellungen",
  phUserProfileDetail_Tab_Header_AccounntInfo: "Mein Konto",
  phUserProfileDetail_Tab_Header_Order: "Meine Bestellungen",
  phUserProfileDetail_Tab_Header_Addresses: "Meine Adressen",
  phUserProfileDetail_Tab_Header_Preferences: "Meine Vorlieben",
  phUserProfileDetail_Billing_Address: "Meine Rechnungsadresse",
  phUserProfileDetail_Delivery_Address: "Meine Lieferadressen",
  phUserProfileDetail_Botton_Label_NewAddress: "Neue Adresse",
  phUserProfileDetail_Save_User_Info: "Speichern",
  phUserProfileDetail_Tags_Subtext: "Hier können Sie Ihre Vorlieben hinterlegen und unser Angebot danach sortieren.",
  phUserProfileDetail_Tags_Title: "Vorlieben",
  phUserProfileDetail_Empty_Order: "Sobald Sie etwas in unserem Shop bestellt haben, können Sie hier Ihre Bestellhistorie einsehen.",
  phUserProfileDetail_Order_List_Header: "Ihre Bestellung vom:",
  phUserProfileDetail_Order_Location: "Standort:",
  phUserProfileDetail_Order_Amount: "Gesamtbetrag:",

  phUserOrderDetail_Date_Time: "Datum/Uhrzeit:",
  phUserOrderDetail_Order_Service: "Bestelltyp:",
  phUserOrderDetail_Payment_Type: "Zahlungsart:",
  phUserOrderDetail_Order_Nr: "Bestellnummer:",
  phUserOrderDetail_State: "Status:",
  phUserOrderDetail_State_In_Progress: "In Bearbeitung",
  phUserOrderDetail_State_Done: "Abgeschlossen",
  phUserOrderDetail_Item_Header: "Artikel",
  phUserOrderDetail_Price_Header: "Preis",
  phUserOrderDetail_NoCOO_Pin_Info_Label: "Pin zur Anzeige Ihrer Rechnung",
  phUserOrderDetail_NoCOO_Pin: "PIN:",
  phUserOrderDetail_Billing_Button_Label: "Zur Rechnung",

  phUserProfileDetail_Delete_Account: "Profil löschen",
  phDeleteAccountDialog_Content: "Sind Sie sicher, dass Sie Ihr Profil bei uns löschen möchten?<br>Durch das Löschen gehen alle gespeicherten Daten verloren und Sie werden automatisch abgemeldet. Dieser Vorgang kann nicht rückgängig gemacht werden.",
  phDeleteAccountDialog_Confirm: "Ihr Profil wurde erfolgreich gelöscht",
  phDeleteAccountDialog_Confirm_Text: "Ihr Profil wurde erfolgreich gelöscht. Bitte drücken Sie auf die nachfolgende Schaltfläche, um zur Startseite zurückzukehren.",

  phUserProfileAddress_MainAddress_Title: "Meine Rechnungsadresse",
  phUserProfileAddress_DeliVeryAddress_Title: "Meine Lieferadresse",
  phUserProfileAddress_NewDeliveryAddress_Title: "Neue Lieferadresse",
  phUserProfileAddress_Save_User_Info: "Speichern",
  phUserProfileAddress_Delete_Address_Button: "Adresse löschen",
  phUserProfileAddress_Announce_Dialog_Title: "Adresse löschen",
  phUserProfileAddress_Announce_Dialog_Content: "Möchten Sie diese Adresse wirklich löschen?",
  phUserProfileAddress_Announce_Dialog_FirestBtn_Label: "Ja",
  phUserProfileAddress_Announce_Dialog_SecondBtn_Label: "Nein",

  phChangePassword_Title: "Passwort ändern",
  phChangePassword_Message: "Bitte geben Sie zum Ändern Ihr aktuelles sowie ein neues Passwort ein",
  phChangePassword_ChangePassword_button: "Passwort ändern",
  phChangePassword_Label_OldPassword: "Altes Passwort",
  phChangePassword_Label_NewPassword: "Neues Passwort",
  phChangePassword_Label_confirmPassword: "Passwort bestätigen",
  phChangePassword_Validate_Password: "Ihr Passwort muss aus 8 Stellen, mindestens einem Buchstaben und einer Zahl bestehen.",
  phChangePassword_Validate_Password_Required: "Das Alte Passwort darf nicht leer sein.",
  phChangePassword_Confirm_Password: "Bitte geben Sie das gleiche Passwort erneut ein",

  phFeedback_Title: "Feedback",
  phFeedback_Modal_Title: "Bewertung",
  phFeedback_Button_Rate: "Ich war voll zufrieden!",
  phFeedback_Button_Feedback: "Verbesserungsvorschläge & Kritik",
  phFeedback_Message: "Das Team von <customer> hofft, dass Sie einen guten Aufenthalt hatten und dass Ihnen die Nutzung der App gefallen hat. Klicken Sie für Feedback bitte auf den jeweiligen Button, je nachdem ob Sie mit der App zufrieden sind, oder Sie Verbesserungsvorschläge haben.",

  phWebvoucher_Detail_Value: "Wert",
  phWebvoucher_Detail_Desired_Value: "Gewünschter Wert",
  phWebvoucher_Detail_Number_Of_Persons: "Personenanzahl",
  phWebvoucher_Detail_Selected_Number_Of_Persons: "Personen",
  phWebvoucher_Detail_Selected_Single_Person: "Person",
  phWebvoucher_Detail_Email_Delivery: "Download",
  phWebvoucher_Detail_Post_Delivery: "Postversand",
  phWebvoucher_Detail_Free_Delivery: "gebührenfrei",
  phWebvoucher_Detail_Plus_Cost_Delivery: "zzgl. Versandkosten",
  phWebVoucher_Detail_Tab_Overview: "Übersicht",
  phWebVoucher_Detail_Tab_Preview: "Vorschau",
  phWebVoucher_Detail_Show_More: "Mehr anzeigen",
  phWebVoucher_Detail_Show_Less: "Weniger anzeigen",

  phWebvoucher_Title: "Code hinzufügen",
  phWebvoucher_button_continue: "Weiter",
  phWebvoucher_button_ToShop: "Zum Shop",
  phWebvoucher_vouchercode_PlaceHolder: "Code hier eingeben",
  phWebvoucher_EnterCode_Title: "Haben Sie bereits einen Gutscheincode?",
  phWebvoucher_EnterCode_Description: "Geben Sie hier bitte die 18-stellige Nummer ein.",
  phWebvoucher_CreateVoucher_Button: "Code erstellen",
  phWebVoucher_CreateVoucher_Title: "Sie haben noch keinen Gutscheincode?",
  phWebVoucher_CreateVoucher_Description: "Um Bonuspunkte zu sammeln oder Guthaben aufzuladen benötigen Sie einmalig einen Gutscheincode, klicken Sie auf \"Code erstellen\" um diesen jetzt zu erzeugen.",
  phWebvoucher_Error_Blocked: "Der Code wurde zu häufig falsch eingeben. Bitte versuchen Sie es in <delaytime> Minuten erneut.",
  phWebvoucher_Error_UsedWebvoucher: "Der eingegebene Code ist ungültig",
  phWebvoucher_Error_WrongWebvoucher: "Der eingegebene Code ist ungültig",
  phWebvoucher_Validate_Code: "Der eingegebene Code ist ungültig",
  phWebvoucher_MuchTry_Title: "Sie haben bereits einige Gutscheincodes...",
  phWebvoucher_MuchTry_Description: "Sie haben bereits mehrfach einen neuen Gutscheincode erzeugt. Bitte wenden Sie sich an unser Servicepersonal in einem unserer Standorte, wir helfen Ihnen gerne weiter.",
  phWebvoucher_MuchTry_Button: "Schließen",

  phWebvoucherDetail_Title: "Ihr QR Code",
  phWebvoucherDetail_button_Title: "Code entfernen",
  phWebvoucherDetail_Date_Caption: "Daten vom",
  phWebvoucherDetail_Button_Refresh: "Aktualisieren",

  phWebvoucherModal_Header: "Code entfernen",
  phWebvoucherModal_Text: "Sollten Sie über mehr als einen Code verfügen, können Sie hier den hinterlegten Code entfernen und einen anderen Code registrieren. Alle Inhalte Ihres bisherigen Codes bleiben selbstverständlich darauf gespeichert und können jederzeit wieder hinzugefügt werden.",
  phWebvoucherModal_TextNote: "<b>WICHTIG:</b> Bitte notieren Sie Ihren aktuellen Code, um diesen später wieder verwenden zu können, dieser lautet",
  phWebvoucherModal_RemoveButton_Label: "Code entfernen",

  phBonusAction_Your_QR: "Ihr QR Code",
  phBonusAction_QR_Text: "Öffnen Sie hier Ihren QR-Code, um Bonuspunkte zu sammeln oder Prämien einzulösen.",
  phBonusAction_Cost_Points: "<points> Punkte",
  phBonusAction_Circle_Points: "Punkte",
  phBonusAction_Redeem_Benefits: "Jetzt Einlösen!",
  phBonusAction_Register_Benefits: "Jetzt Anmelden!",
  phBonusAction_Benefits: "Prämien",
  phBonusAction_Current_Points: "Ihre Punkte:",
  phBonusAction_To_Benefits: "Zu den Details",

  phBonusActionDetails_Location: "Teilnehmende Standorte",

  phCoupon_Show_Code: "Couponcode anzeigen",
  phCoupon_Redeem_Now: "Jetzt im Shop einlösen",
  phCoupon_Members: "Nur für Mitglieder",
  phCouponDetail_Content: "Sie mussen bei <customer> registriert sein, um diesen Coupon nutzen zu können. Noch kein Mitglied? Dann registrieren Sie sich jetzt!",
  phCoupon_Expires_On: "Läuft am",
  phCoupon_Expires_On_End: "ab",
  phCoupon_Expires_Today: "Läuft heute ab",

  phSelectedLayer_Title: "Standort wählen",
  phSelectedLayer_Description: "Bitte wählen Sie Ihren gewünschten Standort aus, diesen können Sie jederzeit über die Titelleiste wechseln.",

  phMenuGroup_Header: "Speisekarte",
  phMenuGroup_DialogHeader: "Alle Kategorien",

  phMenu_DislikeSeperator_title: "Mag ich nicht",

  phMenuDetail_ExtragroupTitle: "Abfrage",
  phMenuDetail_Required: "Pflichtauswahl",

  phLoginDialog_Title: "Nur für <customer> Mitglieder!",
  phLoginDialog_Content: "Sie müssen bei <customer> registriert sein, um diese Funktion nutzen zu können. Noch kein Mitglied? Dann registrieren Sie sich jetzt!",
  phLoginDialog_Content_ModuleName: "Sie müssen bei <customer> registriert sein, um den Bereich <modulename> nutzen zu können. Noch kein Mitglied? Dann registrieren Sie sich jetzt!",

  phUserLike_Header: "Meine Likes",

  phProductDetail_Desciption: "Übersicht",
  phProductDetail_CO2: "CO2",
  phProductDetail_Additives: "Zusatzstoffe",
  phProductDetail_Nutrition: "Nährwerte",
  phProductDetail_Allergy: "Allergene",
  phProductDetail_Content: "Zutatenverzeichnis",
  phProductDetail_Distributor: "Verantwortliches Unternehmen",
  phProductDetail_Labelling: "Produktinformationen",
  phProductDetail_Date_Caption: "Speisekarte vom ",
  phProductDetail_AdditionalInformations: "Weitere Information",
  phProductDetail_ShowAdditionalOption: "Weitere Optionen anzeigen",
  phProductDetail_InfosNotForCustomizedOrders_TEXT: "Angaben beziehen sich nicht auf personalisierte Bestellungen",
  phProductDetail_Announce_Dialog_Title: "Keine Bestellung möglich",
  phProductDetail_Announce_Dialog_Content: "Sie befinden sich in unserem 'stöbern' Bereich, in welchem keine Bestellung getätigt werden kann. Bitte wählen Sie einen anderen Bestelltyp aus.",
  phProductDetail_Announce_Dialog_FirstBtn_Label: "Bestelltyp wählen",
  phProductDetail_Announce_Dialog_SecondBtn_Label: "Weiter stöbern",
  phProductDetail_CurrentlyNotAvailable: "momentan nicht verfügbar",
  phProductDetail_includeDeposit: "inkl. {deposit} Pfand",
  phProductDetail_plusDeposit: "zzgl. {deposit} Pfand",
  phProductDetail_Alcohol_Content: "Alkoholgehalt {value}",
  phProductDetail_Caffeine_Content: "Koffeingehalt {value}",
  phProductDetail_EnterYourDesiredAmount: "Geben Sie Ihren Wunschbetrag ein",
  phProductDetail_prepackaged: "Vorverpackt",

  phExternalLinkModal_confirmation_Title: "Sie verlassen unsere Anwendung",
  phExternalLinkModal_confirmation_Title_eMenu: "Sie verlassen unser eMENU",
  phExternalLinkModal_confirm_Button_Text: "Weiter",

  phConfirmDialog_NoCOO_Title: "Weiterleitung zum Rechnungsportal",
  phConfirmDialog_NoCOO_Text: "Bitte betätigen Sie die nachfolgende Schaltfläche, um zu unserem Rechnungsportal weitergeleitet zu werden.",
  phConfirmDialog_NoCOO_Button: "Weiter",

  phMenuService_Choice: "Bestelltyp",
  phMenuService_PlsChooseService_TEXT: "Bitte wählen Sie aus, wie Sie bei uns bestellen möchten.",
  phMenuService_ViewMenu: "Speisekarte ansehen",
  phMenuService_ViewMenu_SubText: "Möchten Sie einfach nur stöbern und keine Bestellung aufgeben?",
  phMenuService_OderToTable: "Bestellung zum Tisch",
  phMenuService_OrderToTable_SubText: "Im Restaurant direkt mit QR-Code am Tisch bestellen.",
  phMenuService_TakeAway: "Abholung",
  phMenuService_TakeAway_SubText: "Jetzt unkompliziert bestellen und gleich vor Ort abholen.",
  phMenuService_Delivery: "Lieferung",
  phMenuService_Delivery_SubText: "Einfach Ihre Position angeben, Standort auswählen und los.",
  phMenuService_Webvoucher_WithCharging: "Gutschein & Guthaben",
  phMenuService_Webvoucher_SubText_WithCharging: "Hier können Sie Ihr Guthaben aufladen, oder Gutscheine bestellen.",
  phMenuService_Webvoucher: "Gutschein",
  phMenuService_Webvoucher_SubText: "Hier Gutscheine bestellen und gleich per E-Mail erhalten.",

  phWebshop_ShippingCart_Nav_Header: "Warenkorb",
  phWebshop_OrderData_Nav_Headero: "Kundendaten",
  phWebshop_Payment_Nav_Header: "Bezahlung",
  phWebshop_FreeShippingAt_BASE: "Fügen Sie noch Artikel im Wert von {amount} hinzu, um keine Liefergebühren zu zahlen.",
  phWebshop_PleaseChooseDeliveryCountry: "Bitte wählen Sie das Lieferland aus:",
  phWebshop_Abholtag_Label: "Abholtag",
  phWebshop_Liefertag_Label: "Liefertag",
  phWebshop_AsSoonAsPossible: "Schnellstmöglich",
  phWebshop_Abholzeit_NextDay_Label: "Abholzeit",
  phWebshop_Lieferzeit_NextDay_Label: "Lieferzeit",
  phWebshop_InHause_Time: "Bestellzeit: Jetzt",
  phWebshop_NoDelivery_Time: "Heute ist leider keine Lieferung möglich",
  phWebshop_NoPickup_Time: "Heute ist leider keine Abholung möglich",
  phWebshop_NoInHause_Time: "Heute ist leider keine Bestellung zum Tisch möglich",
  phWebshop_Item_Show_Comment: "Anmerkung",
  phWebshop_Item_Hide_Comment: "Anmerkung",
  phWebshop_ShippingCart_Total: "Total",
  phWebshop_ShippingCart_MinimumDelivery: "Mindestbestellwert",
  phWebshop_Shippingcart_next: "Jetzt bestellen",
  phWebshop_Shippingcart_tip: "Trinkgeld",
  phWebshop_Shippingcart_DeliveryFee: "Liefergebühr",
  phWebshop_Shippingcart_SumOfProducts: "Summe",
  phWebshop_Shippingcart_IncludeDeposit_BASE: "inkl. {deposit} Pfand",
  phWebshop_Recommendation_Title: "Zu Ihrer Bestellung empfehlen wir:",
  phWebshop_View_Cart: "Warenkorb ansehen",

  phWebshop_includeDeposit: "inkl. Pfand",
  phWebshop_plusDeposit: "zzgl. Pfand",

  phOrderData_Username_Announce: "Sie sind angemeldet als",
  phOrderData_Guest_register_comment: "Registrieren Sie sich in wenigen Schritten, um alle Vorteile zu nutzen und Ihre nächste Bestellung schneller und einfacher abzuschließen.",
  phOrderData_Order_As_Guest: "Oder bestellen Sie als Gast",
  phOrderData_Order_Following_Information: "Für die weitere Bearbeitung benötigen wir noch folgende Angaben von Ihnen.",
  phOrderData_selectBillAddress: "Ihre Rechnungsadresse",
  phOrderData_selectAddress: "Lieferadresse auswählen",
  phOrderData_selectNewAddress: "Neue Lieferadresse auswählen",
  phOrderData_addNewAddress: "Neue Adresse anlegen",

  phPayment_Webvoucher_Usage: "Gutschein verwenden",
  phPayment_RedeemWebvoucher: "Gutscheincode einlösen (18-Stellig)",
  phPayment_Webvoucher_Info_BASE: "Ihr Gutschein ({Nr}) hat einen Wert von {Amount}",
  phPayment_Webvoucher_Info_Discount_BASE: "Ihr Gutschein ({Nr}) hat einen Wert von {Amount} und einen Rabatt in Höhe von {Discount}",
  phPayment_Webvoucher_OnlyNr_BASE: "Ihr Gutschein hat die Nummer {SimpleNr}",
  phPayment_Webvoucher_OnlyNrAndDiscount_BASE: "Ihr Gutschein ({Nr}) hat einen Rabatt in Höhe von {Discount}",
  phPayment_Validate_WebvoucherPattern: "Gutschein-Code muss eine 18-stellige Nummer sein",
  phPayment_Validate_WebvoucherExists: "Kein gültiger Gutschein konnte gefunden werden",
  phPayment_PayPal: "PayPal",
  phPayment_MPA: "Auf Rechnung",
  phPayment_CashlessTakeaway: "Bargeldlos bei Abholung",
  phPayment_CashlessDelivery: "Bargeldlos bei Lieferung",
  phPayment_CashDelivery: "Bar bei Lieferung",
  phPayment_PayOnCollection: "Bezahlung bei Abholung",
  phPayment_Webvoucher: "Webgutschein",
  phPayment_PayAtWaiter: "An der Kasse bezahlen",
  phPayment_FinalPrice: "Zu zahlender Betrag",
  phPayment_ChooseYourPaymentMethod: "Wählen Sie Ihre Zahlungsart",
  phPayment_MorePaymentMethods: "Weitere Zahlungsmöglichkeiten",
  phPayment_AcceptTerms_BASE: "Mit der zahlungspflichtigen Bestellung akzeptieren Sie die {customer}-{terms}",
  phPayment_OrderNowWithCosts: "Jetzt kostenpflichtig bestellen",
  phPayment_PayNow: "Jetzt bezahlen",
  phPayment_CommentToYourOrder: "Haben Sie Anmerkungen zur Bestellung?",
  phPayment_UnsupportedCardType_Title: "Nicht unterstützer Kartentyp",
  phPayment_UnsupportedCardType_Content: "Der Kartentyp dieser Nummer wird nicht als Zahlungsmethode unterstützt. Bitte überprüfen Sie Ihre eingegebenen Kartennummer oder verwenden Sie eine andere Zahlungsart.",
  phPayment_UnsupportedCardType_Button: "Zurück",

  phPayment_MethodName_amex: "American Express",
  phPayment_MethodName_applepay: "Apple Pay",
  phPayment_MethodName_diners: "Diners",
  phPayment_MethodName_directEbanking: "Sofort",
  phPayment_MethodName_discover: "Discover",
  phPayment_MethodName_jcb: "JCB",
  phPayment_MethodName_mc: "Mastercard",
  phPayment_MethodName_paypal: "PayPal",
  phPayment_MethodName_paywithgoogle: "Google Pay",
  phPayment_MethodName_visa: "Visa",
  phPayment_MethodName_unknown: "Unbekannt",
  phPayment_MethodName_Cash_DeliveryTakeAway: "Bar",
  phPayment_MethodName_ec: "EC",
  phPayment_MethodName_EcNational: "Ec-National",
  phPayment_MethodName_EcInternational: "Ec-International",
  phPayment_MethodName_EcForeign: "Ec-Ausland",
  phPayment_MethodName_ECustomerCard: "Ec-Kundenkarte",
  phPayment_MethodName_Breuninger: "Breuninger",
  phPayment_MethodName_ecCash: "Ec-Cash",
  phPayment_MethodName_sonstigeKreditkarten: "Sonstige Kreditkarten",
  phPayment_MethodName_AdrevaMacao: "AdrevaMacao",
  phPayment_MethodName_IKEAFamilyCard: "IKEAFamilyCard",
  phPayment_MethodName_VisaDebit: "Visa Debit",
  phPayment_MethodName_MCDebit: "MC Debit",
  phPayment_MethodName_Maestro: "Maestro",
  phPayment_MethodName_VPay: "VPay",
  phPayment_MethodName_Postcard: "Postcard",
  phPayment_MethodName_PayPalPicturePayment: "PayPalPicturePayment",
  phPayment_MethodName_Deposit: "Einzahlung",
  phPayment_MethodName_Payout: "Auszahlung",
  phPayment_MethodName_TWINT: "TWINT",
  phPayment_MethodName_WebInvoice: "WebInvoice",
  phPayment_MethodName_ZahlungAnstehend: "Zahlung Anstehend",
  phPayment_MethodName_CashController: "CashController",
  phPayment_MethodName_PayPerApp: "PayPerApp",
  phPayment_MethodName_Cashess_Delivery: "Bargeldlos",
  phPayment_MethodName_PayDirect: "Paydirekt",
  phPayment_MethodName_LunchCard: "Lunch Card",
  phPayment_MethodName_LunchCheckCard: "Lunch Check Card",
  phPayment_MethodName_MaestroCH: "Maestro CH",
  phPayment_MethodName_PowerCard: "Power Card",
  phPayment_MethodName_Loeb: "Loeb",
  phPayment_MethodName_Manorcard: "Manorcard",
  phPayment_MethodName_WIRcard: "WIRcard",
  phPayment_MethodName_Reka: "Reka",
  phPayment_MethodName_Giftcard: "Giftcard",
  phPayment_MethodName_ChinaUnionPay: "China UnionPay",
  phPayment_MethodName_Alipay: "Alipay",
  phPayment_MethodName_WeChat: "WeChat",
  phPayment_MethodName_Sodexo: "Sodexo",
  phPayment_MethodName_TWINTTerminal: "Twint Terminal",
  phPayment_MethodName_OnlineZahlung: "Online Zahlung",
  phPayment_MethodName_AmazonPay: "AmazonPay",
  phPayment_MethodName_klarna_paynow: "Klarna Pay Now",
  phPayment_MethodName_EPS_AT: "EPS AT",
  phPayment_MethodName_Paysafecard: "PaySafecard",
  phPayment_MethodName_Wallet: "Wallet",
  phPayment_MethodName_Sepa: "SEPA",
  phPayment_MethodName_Girocard: "Girocard",
  phPayment_MethodName_Voucher: "Webgutschein",
  phPayment_MethodName_MPA: "Auf Rechnung",
  phPayment_MethodName_Cashless_DeliveryTakeaway: "Bargeldlos",
  phPayment_MethodName_PayAtPOS: "Zahlen am POS",
  phPayment_MethodName_scheme: "Kartenzahlung",

  phHome_Today: "Heute",

  phArticleCard_ArticleUnavailable: "Dieser Artikel ist leider momentan nicht verfügbar",
  phArticleCard_Recipe_Price_from: "ab",

  phAvailableService_title_Delivery: "Schön, dass Sie bei uns bestellen möchten.",
  phAvailableService_title_Tekeaway: "Schön, dass Sie bei uns zur Abholung bestellen möchten.",
  phAvailableService_title_InHouse: "Schön, dass Sie bei uns \"am Tisch\" bestellen möchten.",
  phAvailableService_title_OpenTime: "Schön, dass Sie bei uns bestellen wollen!",
  phAvailableService_content_Delivery: "Aktuell haben wir leider geschlossen, wir nehmen Ihre Bestellung aber gerne bereits entgegen und beliefern Sie innerhalb unserer Öffnungszeiten. Wählen Sie Ihre gewünschte Lieferzeit einfach am Ende Ihrer Bestellung aus.",
  phAvailableService_content_Tekeaway: "Aktuell haben wir leider geschlossen, wir nehmen Ihre Bestellung aber gerne bereits entgegen, so dass Sie diese innerhalb unserer Öffnungszeiten abholen können. Wählen Sie Ihre gewünschte Abholzeit einfach am Ende Ihrer Bestellung aus.",
  phAvailableService_content_InHouse: "Leider möchten Sie außerhalb unserer Bestellzeiten bestellen. Diese lauten:",
  phAvailableService_content_OpenTime: "Wie es aussieht haben wir gerade geschlossen. Bitte beachten Sie unsere Öffnungszeiten bei Ihrer Bestellung.",

  phMenuChangeLocationDialog_YouAreInLocation_BASE: "Sie befinden sich in {location}.",
  phMenuChangeLocationDialog_YouAreKmAway_BASE: "Sie sind > {distance} km vom Restaurant entfernt.",
  phMenuChangeLocationDialog_Address: "Adresse",
  phMenuChangeLocationDialog_Opentimes: "Öffnungszeiten",
  phMenuChangeLocationDialog_ChangeLocation: "Standort wechseln",
  phMenuChangeLocationDialog_ChangeService: "Bestellart wechseln",

  phOrderDataInputs_prefix: "Anrede",
  phOrderDataInputs_fname: "Vorname",
  phOrderDataInputs_name: "Name",
  phOrderDataInputs_companyAddress: "Firmenadresse",
  phOrderDataInputs_co: "C/O",
  phOrderDataInputs_address: "Straße & Hausnummer",
  phOrderDataInputs_addition: "Zusatz",
  phOrderDataInputs_zip_code: "PLZ",
  phOrderDataInputs_city: "Ort",
  phOrderDataInputs_country: "Land",
  phOrderDataInputs_email: "E-Mail",
  phOrderDataInputs_telephone1: "Telefon privat",
  phOrderDataInputs_telephone2: "Telefon geschäftlich",
  phOrderDataInputs_telephone_mobile: "Telefon mobil",
  phOrderDataInputs_fax: "Fax",
  phOrderDataInputs_privatAccess: "Erreichbarkeit von - Erreichbarkeit bis (privat)",
  phOrderDataInputs_workAccess: "Erreichbarkeit von - Erreichbarkeit bis (geschäftlich)",
  phOrderDataInputs_bday_ymd: "Geburtsdatum",

  phOrderDataInputs_Name_Validate_Error: "Der Name darf nicht leer sein.",
  phOrderDataInputs_Family_Validate_Error: "Der Nachname darf nicht leer sein.",
  phOrderDataInputs_Gender_Validate_Error: "Das Geschlecht darf nicht leer sein.",
  phOrderDataInputs_address_Validate_Error: "Der Adresse darf nicht leer sein.",
  phOrderDataInputs_zip_code_Validate_Error: "Der Postleitzahl darf nicht leer sein.",
  phOrderDataInputs_city_Validate_Error: "Die Ort darf nicht leer sein.",
  phOrderDataInputs_addition_Validate_Error: "Der Zusatz darf nicht leer sein.",
  phOrderDataInputs_country_Validate_Error: "Das Land darf nicht leer sein.",
  phOrderDataInputs_co_Validate_Error: "C/O darf nicht leer sein.",
  phOrderDataInputs_bday_ymd_DateNotValid_Error: "Geburtsdatum ist ungültig.",
  phOrderDataInputs_bday_ymd_Validate_Error: "Geburtsdatum darf nicht leer sein.",

  ph_menuLocation_Select_PostalCode: "Bitte geben Sie hier Ihre Postleitzahl ein",
  ph_menuLocation_Search: "PLZ oder Stadt eingeben",
  ph_menuLocation_cityList: "Ort auswählen",
  ph_menuLocation_ZipCode_Warning_Title: "Wohin möchten Sie beliefert werden?",
  ph_menuLocation_ZipCode_Warning_Content: "Bitte geben Sie Ihre PLZ ein, damit wir prüfen können, ob Sie sich in unserem Liefergebiet befinden.",
  ph_menuLocation_ZipCode_Warning_BtnLabel: "PLZ eingeben",
  ph_menuLocation_ZipCode_Warning_Option: "Sollten wir Sie nicht beliefern können, können Sie Ihre Bestellung natürlich auch gerne bei uns abholen. Wählen Sie hierfür bitte den Bestelltyp „Abholung“ aus.",
  ph_menuLocation_Other_Postalcode: "PLZ ändern",
  ph_menuLocation_Your_Current_Location: "Aktuelle Postleitzahl: ",
  ph_menuLocation_Announce_Dialog_Title: "Keine Lieferung möglich",
  ph_menuLocation_Announce_Dialog_Content: "Ihre aktuelle Position können wir leider nicht beliefern. Bitte geben Sie eine andere Postleitzahl an, oder änderen Sie den Bestelltyp.",
  ph_menuLocation_Announce_Dialog_FirstBtn_Label: "Andere Postleitzahl",
  ph_menuLocation_Announce_Dialog_SecondBtn_Label: "Bestelltyp wählen",
  ph_MenuLocation_WebVoucher_Title: "Welcher ist Ihr Lieblingsstandort?",
  ph_MenuLocation_WebVoucher_SubTitle: "Selbstverständlich können Sie unsere Gutscheine in allen Standorten einlösen.",

  ph_orderAddressQuery_ApproximatedAddress_Title: "Wir konnten keine genaue Adresse herausfinden",
  ph_orderAddressQuery_ApproximatedAddress_Content: "Leider konnten wir keine genaue Adresse zu Ihren Angaben finden. Sie können die Adresse korrigieren oder mit der angegebenen Postleitzahl weitermachen.",
  ph_orderAddressQuery_ApproximatedAddress_BtnLabel: "Weiter mit PLZ",
  ph_orderAddressQuery_ApproximatedAddress_Option: "Sollten wir Ihre genaue Adresse momentan nicht finden können, können Sie trotzdem mit der Postleitzahl weitermachen. Falls wir Sie nicht beliefern können, können Sie Ihre Bestellung natürlich auch gerne bei uns abholen. Wählen Sie hierfür bitte den Bestelltyp „Abholung“ aus.",

  phOrderResult_ThankYouForYourOrder: "Vielen Dank für Ihre Bestellung",
  phOrderResult_ConfirmationMailSend_TEXT: "Wir haben Ihnen soeben eine Bestellbestätigung per E-Mail an {email} geschickt.",
  phOrderResult_Success_YourOrder: "Ihre Bestellung:",
  phOrderResult_SuccessDelivery_BASE_Nostreet: "Ihre Bestellung ({orderid}) wird {time} ausgeliefert.",
  phOrderResult_SuccessDelivery_BASE: "Ihre Bestellung ({orderid}) wird{day} {time} in der {street} ausgeliefert.",
  phOrderResult_SuccessInHause_BASE: "Ihre Bestellung ({orderid}) ist bei uns eingegangen und kommt in kurzer Zeit zu Ihnen an den Tisch!",
  phOrderResult_SuccessPickup_BASE_Nostreet: "Ihre Bestellung ({orderid}) ist {time} zur Abholung bereit.",
  phOrderResult_SuccessPickup_BASE: "Ihre Bestellung ({orderid}) ist{day} {time} zur Abholung in der {street} bereit.",
  phOrderResult_SuccessDelivery_BASE_Hero_Nostreet: "({orderid}) wird {time} ausgeliefert.",
  phOrderResult_SuccessDelivery_BASE_Hero: "({orderid}) wird{day} {time} in der {street} ausgeliefert.",
  phOrderResult_SuccessPickup_BASE_Hero_Nostreet: "({orderid}) ist {time} zur Abholung bereit.",
  phOrderResult_SuccessPickup_BASE_Hero: "({orderid}) ist{day} {time} zur Abholung in der {street} bereit.",
  phOrderResult_Success_Retail_WillBePackaged_TEXT: "wird umgehend verpackt und in den nächsten Tagen an Sie versandt.",
  phOrderResult_DayAtPrefix: "am",
  phOrderResult_TimeAboutPrefix: "um ca.",
  phOrderResult_AsSoonAsPossible: "Schnellstmöglich",
  phOrderResult_PhoneNumberForCallback: "Telefonnummer für Rückfragen",
  phOrderResult_ToTheHomescreen: "Zum Startbildschirm",
  phOrderResult_YourOrderWasCancelled: "Ihre Bestellung wurde leider abgebrochen, bitte versuchen Sie es erneut",
  phOrderResult_DoYouWantToContinue_TEXT: "Möchten Sie Ihre Bestellung fortsetzen oder eine andere Zahlungsmethode wählen? Dann wählen Sie zurück zum Check-Out.",
  phOrderResult_ReturnToCheckout: "Zurück zum Check-Out",
  phOrderResult_OrderCouldNotBeAccepted: "Ihre Bestellung konnte leider nicht angenommen werden",
  phOrderResult_ThereWasAProblem_TEXT: "Anscheinend hat es Probleme bei Ihrer Bestellung gegeben, bitte versuchen Sie es mit einer anderen Zahlungsmethode.",
  phOrderResult_CollectedPointsForBonus_BASE: "Sie haben {points} für die Bonusaktion {bonusaction} gesammelt!",
  phOrderResult_Points: "Punkte",
  phOrderResult_Point: "Punkt",
  phOrderResult_SuccessWebvoucher_DownloadText: "Über die nachfolgenden Links können Sie Ihre Gutscheine herunterladen.",
  phOrderResult_SuccessWebvoucher_ConfirmationMailSend: "Zusätzlich haben wir Ihnen diese auch per E-Mail an {email} geschickt.",
  phOrderResult_SuccessWebvoucher_ConfirmationPostSend: "Ihre Gutscheine senden wir in Kürze an die von Ihnen angegebene Lieferadresse.",
  phOrderResult_WebVoucherOrderList_header: "Gutschein(e)",
  phOrderResult_SuccessWebvoucher_TitleVoucher: "Gutschein",
  phOrderResult_SuccessWebvoucher_Person_Count: "Personen",
  phOrderResult_SuccessWebvoucher_Person_Post_Delivery: "Postversand",
  phOrderResult_SuccessWebvoucher_Person_Mail_Delivery: "Download",
  phOrderResult_SuccessWebvoucher_TitleAmount: "Betrag",
  phOrderResult_SuccessWebvoucher_TitleLink: "Link zum Gutschein",
  phOrderResult_SuccessWebvoucher_TextLink: "PDF",
  phOrderResult_SuccessWebvoucher_ButtonLink: "Gutschein(e) herunterladen",
  phOrderResult_SuccessTicket_DownloadText: "Über die nachfolgenden Links können Sie Ihre Tickets herunterladen.",
  phOrderResult_SuccessTicket_TitleTicket: "Tickets",
  phOrderResult_SuccessTicket_ButtonLink: "Ticket(s) herunterladen",
  phOrderResult_SuccessTicket_DownloadInfo: "Über die nachfolgenden Links können Sie Ihre Tickets herunterladen.",
  phOrderResult_CloseTab: "Tab schließen",
  phOrderResult_VoucherCredit_Charge: "Wir haben Ihnen Ihr Guthaben um Ihren Wunschbetrag erhöht.",

  phInvalidDeliveryAddress_Title: "Das hat nicht funktioniert",
  phInvalidDeliveryAddress_content: "Diese Adresse kann leider nicht von dem ausgewählten Standort beliefert werden. Bitte wählen Sie eine andere Lieferadresse, oder einen anderen Standort aus. Sollten Sie einen anderen Standort auswählen, so wird der Warenkorb bei einem Wechsel entleert.",

  phResetBasketWarning_Title: "Produkte im Warenkorb",
  phResetBasketWarning_SubHeaderContent: "Sie haben noch Produkte für Standort {locationName} hinterlegt.",
  phResetBasketWarning_Content: "Möchten Sie mit einer neuen Auswahl starten oder die jetzige Bestellung fortsetzen?",
  phResetBasketWarning_RemainOrder_Button: "Fortsetzen",
  phResetBasketWarning_ResetBasket_Button: "Neue Bestellung",

  phDiscardBasketDialog_Title: "Bestellung wirklich verwerfen?",
  phDiscardBasketDialog_Content: "Möchten Sie Ihre Bestellung wirklich verwerfen und auf anderem Wege bei uns bestellen?",
  phDiscardBasketDialog_RemainOrder_Button: "Zurück",
  phDiscardBasketDialog_ResetBasket_Button: "Bestellung verwerfen",

  phWebshopVacationWarning_Button: "Okay",

  phQRCode_Page_Title: "Im Haus Bestellung",
  phQRCode_page_Description: "Bitte scannen Sie den Tischcode, um jetzt bei uns zu bestellen.",
  phQRCode_Access_Denied_Text: "Leider können wir nicht auf Ihre Kamera zugreifen.<br><br>Bitte kontrolliere gegebenenfalls Ihr Handy- oder Browsereinstellungen.",
  phQRCode_PlaceHolder: "5-stelliger Tischcode",
  phQRCode_Page_Button: "Tischcode eingeben",
  phQRCode_ScanFail_Title: "Der QR Code ist nicht lesbar",
  phQRCode_ScanFail_Content: "Leider konnte der QR Code nicht gelesen werden. Geben Sie den QR Code in die Textfläche ein.",
  phQRCode_ScanFail_Button_Text: "Schließen",
  phQRCodeScanner_NoCamera_HTML: "Keine Kamera? Kein Problem!<br>Geben Sie einfach den 5-stelligen Tischcode ein und bestellen Sie sofort.",

  phQRCode_Manual_Page_Title: "Im Haus Bestellung",
  phQRCode_Manual_Page_Description: "Bitte geben Sie hier Ihren 5-stelligen Tischcode ein.",
  phQRCode_Manual_Page_Button: "Weiter",
  phQRCode_Manual_Validate: "Tischcode ist ungültig",

  phInHouseOrdering_Title: "Bestellung zum Tisch",
  phInHouseOrdering_description: "Bestellen Sie jetzt bequem mit dem Smartphone und erhalten Sie Ihre Bestellung in kurzer Zeit direkt an den Tisch.",
  phInHouseOrdering_Button_Text: "Weiter",

  phInHouse_NoQRCode_Warning_Title: "Der Tischcode ist leider nicht gültig",
  phInHouse_NoQRCode_Warning_Description: "Leider ist der von Ihnen eingegebene Tischcode nicht gültig. Bitte kontrollieren Sie Ihre Eingabe oder wenden Sie sich an unseren Service. Wir helfen Ihnen gerne weiter.",
  phInHouse_NoQRCode_Warning_Button_Text: "Schließen",

  phInHouse_NoLocation_Warning_Title: "Bestelltyp nicht verfügbar",
  phInHouse_NoLocation_Warning_Description: "Der von Ihnen aufgerufene Bestelltyp ist leider nicht verfügbar, bitte wenden Sie sich an unser Servicepersonal.",
  phInHouse_NoLocation_Warning_Button_Text: "Zum Startbildschirm",

  phVoucherCredit_Page_Title: "Gutschein & Guthaben",
  phVoucherCredit_Page_Description: "Möchten Sie Ihre Kundenkarte aufladen oder einen neuen Geschenkgutschein bestellen?",
  phVoucherCredit_Credit_Title: "Guthaben aufladen",
  phVoucherCredit_Credit_Description: "Prepaid-Guthaben aufladen und zukünftig bargeldlos bezahlen.",
  phVoucherCredit_Voucher_Title: "Gutschein bestellen",
  phVoucherCredit_Voucher_Description: "Hier Gutscheine bestellen, und gleich per E-Mail erhalten.",
  phVoucherCredit_Warning_Title: "Entschuldigung...",
  phVoucherCredit_Warning_Description: "Leider konnten wir Ihre Anfrage nicht verarbeiten. Bitte versuchen Sie es später erneut.",

  phNewOrderTimeDialog_Title: "Wie die Zeit vergeht...",
  phNewOrderTimeDialog_Description: "Leider können wir Ihre Bestellung nicht mehr zum gewünschten Zeitpunkt ausführen.<br>Bitte wählen Sie eine neue Zeit aus.",
  phNewOrderTimeDialog_Description_Closed: "Leider können wir Ihre Bestellung heute nicht mehr annehmen.<br> Bitte kommen Sie doch morgen wieder hier vorbei.",
  phNewOrderTimeDialog_Button_NewTime: "Weiter",
  phNewOrderTimeDialog_Button_Close: "Abbrechen",

  phCookie_Cookie: "Cookies",
  phCookieBanner_Title: "Wir verwenden Cookies",
  phCookieBanner_Button_Accept: "Annehmen",
  phCookieBanner_Button_Deny: "Ablehnen",
  phCookieBanner_Button_Accept_All: "Alle Cookies akzeptieren",
  phCookieBanner_Button_Infos: "Datenschutz-Information",

  phCookieBanner_Content: "Wir möchten unseren Service für Sie so nutzerfreundlich wie möglich gestalten. Damit wir unsere Funktionen optimal anbieten können, werden notwendige Cookies eingesetzt. Die Verarbeitung Ihrer personenbezogenen Daten können Sie unserer Datenschutz-Information entnehmen. Den Erhalt und Ihr Verständnis der Datenschutz-Information zum Einsatz von notwendigen Cookies bestätigen Sie durch den nachfolgenden Button.",

  phCookieStatement_Title_First: "Notwendige Verarbeitung von personenbezogenen Daten",
  phCookieStatement_Title_Second: "Notwendige Cookies",

  phCookieStatement_Button_Close: "Schließen",
  phCookieStatement_Table_cookieName: "Cookiename",
  phCookieStatement_Table_URL: "URL",
  phCookieStatement_Table_service: "Service",
  phCookieStatement_Table_validity: "Aufbewahrungsdauer",
  phCookieStatement_Table_country: "Ort der Verarbeitung",
  phCookieStatement_Table_active: "Aktiv",
  phCookieStatement_Table_description: "Zweck der Datenverarbeitung",
  phCookieStatement_Table_company: "Verarbeitendes Unternehmen",
  phCookieStatement_Table_rightTerms: "Rechtliche Grundlage",
  phCookieStatement_Table_technology: "Genutzte Technologien",
  phCookieStatement_Table_dataCollect: "Gesammelte Daten",
  phCookieStatement_Table_dataRecipient: "Datenempfänger",
  phCookieStatement_Table_dataProtectionOfficer: "Datenschutzbeauftragter des verarbeitenden Unternehmens",
  phCookieStatement_Table_dataProcessors: "Klicken Sie hier, um die Datenschutzbestimmungen des Datenverarbeiters zu lesen",

  phFilterTagDialog_Title: "Vorlieben",
  phFilterTagDialog_Description: "Hier können Sie Ihre Vorlieben hinterlegen und unser Angebot danach sortieren.",
  phFilterTagDialog_Button_Save: "Übernehmen",
  phFilterTagDialog_Button_Close: "Zurücksetzen",
  phFilterTagDialog_Checkbox_Content: "Einstellung für zukünftige Bestellungen merken",

  phFixedBasketErrorPage_PleaseTryAgainLater_Text: "Unser Angebot wird gerade aktualisiert, bitte versuchen Sie es in einigen Minuten erneut. Vielen Dank für Ihr Verständnis.",
  phFixedBasketErrorPage_NoBasket_Text: "Die Bestellung wurde schon durchgeführt oder der Warenkorb ist veraltet. Bitte führen Sie die Bestellung noch einmal durch. Vielen Dank für Ihr Verständnis.",

  phOpenLinkInApp_Text: "Link in App öffnen?",
  phOpenLinkInApp_Action_Open: "Anzeigen",

  phInHouseOrder_CloseOrdering_Button: "Tisch verlassen",

  phServiceCall_Title: "Serviceruf",
  phServiceCall_Description: "Wie können wir Ihnen weiterhelfen?",
  phServiceCall_SecureCheckDialog_Title: "Möchten Sie den Serviceruf jetzt übermitteln?",
  phServiceCall_SecureCheckDialog_AcceptBtn_Label: "Bestätigen",
  phServiceCall_SecureCheckDialog_DenyBtn_Label: "Abbrechen",
  phServiceCall_Success_Title: "Der Serviceruf wurde erfolgreich übermittelt, wir werden uns schnellstmöglich um Ihr Anliegen kümmern.",
  phServiceCall_Fail_Title: "Serviceruf fehlgeschlagen!",
  phServiceCall_Button: "Ok",

  phInHouseService_Ordered_Items: "Bestellte Artikel",
  phInHouseService_Open_Bill: "Offene Rechnung",
  phInHouseService_NoOrderYet_Title: "Keine Artikel zur Zahlung vorhanden",
  phInHouseService_NoOrderYet_Description: "Es sind noch keine Artikel auf diesem Tisch zur Zahlung vorhanden. Bitte tätigen Sie erst eine Bestellung, um diese Funktion nutzen zu können.",
  phInHouseService_Button_Text: "Sie sind eingeloggt auf",
  phInHouseService_Table: "Tisch {table_no}",
  phInHouseService_Group: "Bestellgruppe {group}",
  phInHouseService_Guest: "Gast {seat_no}",
  phInHouseService_Items: "{items_count} Artikel",
  phInHauseService_Leave_Table_Dialog_Title: "Möchten Sie den Tisch wirklich verlassen?",
  phInHauseService_Leave_Table_Content: "Es sind noch nicht alle Artikel bezahlt oder es befinden sich noch nicht bestellte Artikel im Warenkorb. Möchten Sie den Tisch wirklich verlassen?",
  phInHauseService_Leave_Table_Dialog_Button: "Tisch verlassen",

  phInHouseOrderResult_ThankYouForYourVisit: "Vielen Dank für Ihren Besuch",
  phInHouseOrderResult_SuccessfullPayment: "Vielen Dank für Ihren Besuch, wir haben Ihre Zahlung erhalten.",
  phInHouseOrderResult_SuccessfullPayment_SecondParagraph: "Wir würden uns freuen, Sie bald wieder bei uns begrüßen zu dürfen.",
  phInHouseOrderResult_OpenItems: "Auf Ihrem Tisch befinden sich noch {items} unbezahlte Artikel, mit einer Summe von {total} EUR.",
  phInHouseOrderResult_ToNoCOO: "Zur Rechnung",
  phInHouseOrderResult_ToTable: "Zur Tischübersicht",
  phInHouseOrderResult_ToTheHomescreen: "Zum Startbildschirm",
  phInHouseOrderResult_YourPaymentWasCancelled: "Ihre Bezahlung wurde leider abgebrochen, bitte versuchen Sie es erneut",
  phInHouseOrderResult_DoYouWantToContinue_TEXT: "Möchten Sie eine andere Zahlungsmethode wählen? Dann wählen Sie zurück zum Check-Out.",
  phInHouseOrderResult_PaymentCouldNotBeAccepted: "Ihre Bezahlung konnte leider nicht angenommen werden",
  phInHouseOrderResult_ThereWasAProblem_TEXT: "Anscheinend hat es Probleme bei Ihrer Bezahlung gegeben, bitte versuchen Sie es mit einer anderen Zahlungsmethode.",
  phInHouseOrderResult_FailedPaymentDialog_Title: "Zahlung fehlgeschlagen",
  phInHouseOrderResult_FailedPaymentDialog_Text: "Ihre Zahlung ist leider fehlgeschlagen, bitte versuchen Sie es erneut, oder wenden Sie sich an unser Servicepersonal.",
  phInHouseOrderResult_FailedPaymentDialog_Button: "Abbrechen ",
  phInHouseOrderResult_Mandatory_Payment_Header: "Vielen Dank für Ihre Bestellung",
  phInHouseOrderResult_Mandatory_Payment_Info: "Ihre Bestellung auf Tischnummer {table_no} ist bei uns eingegangen.",
  phInHouseOrderResult_Mandatory_Payment_PayAtWaiter: "Bitte bezahlen Sie jetzt die Bestellung an der Kasse, indem Sie den QR-Code vorzeigen. Nach der vollständigen Zahlung wird Ihre Bestellung abgeschlossen.",
  phInHouseOrderResult_AnnounceDialog_PayAtWaiter_Title: "Zahlung ist ausstehend",
  phInHouseOrderResult_AnnounceDialog_PayAtWaiter_Content: "Die Zahlung an der Kasse ist ausstehend. Sie benötigen den QR-Code, um die Bestellung abzuschließen. Haben Sie bereits gezahlt und möchten zum Startbildschirm?",
  phInHouseOrderResult_AnnounceDialog_PayAtWaiter_StayBtn: "Zurück",

  phInHouseTableClose_Title: "Tisch schließen",
  phInHouseTableClose_Content: "Sie möchten den Tisch abschließen. Falls andere Personen noch nicht bestellt haben, werden sie abgemeldet und der Tisch wird geschlossen.",
  phInHouseTableClose_Btn_Confirm: "Bezahlung fortsetzen",
  phInHouseTableClose_Btn_Cancel: "Abbrechen",

  phAgeDialog_Title: "Altersfreigabe erst ab {age} Jahren!",
  phAgeDialog_Note: "Hiermit bestätigen Sie, dass Sie mindestens das oben genannte Alter erreicht haben und berechtigt sind, diesen Artikel zu bestellen.",
  phAgeDialog_Confirm_Btn: "Ja, ich habe das oben genannte Alter erreicht.",
  phAgeDialog_Deny_Btn: "Nein, ich habe das oben genannte Alter noch nicht erreicht.",
  phAgeDialog_Notice: "Wir behalten uns vor, eine Alterskontrolle durchzuführen.",

  phLocation_Required_Dialog_Title: "Standortbestimmung erforderlich",
  phLocation_Required_Dialog_Sub_Text: "Bitte aktivieren Sie die Standortbestimmung Ihres Handys, um mit der Bestellung fortzufahren.",
  phLocation_Dialog_Distance_Title: "Sind Sie nicht in unserem Restaurant?",
  phLocation_Dialog_Distance_Sub_Text: "Sie scheinen sich nicht an unserem Standort zu befinden, bitte verwenden Sie einen anderen Bestelltyp.",
  phLocation_Required_Dialog_Button: "Schließen",

  phInHouse_Payment_Select_Btn: "Auswählen",
  phInHouse_Payment_Select_All: "Alle auswählen",
  phInHouse_Payment_Select_Own_Items: "Meine eigenen auswählen",
  phInHouse_Payment_Select_None: "Alle abwählen",
  phPayment_Tab_Order_Overview: "Bestellübersicht",
  phPayment_Tab_Order_Data: "Kundendaten",
  phPayment_Tab_Order_Pay: "Bezahlung",
  phInHouse_Payment_User_Place: "Platz {placeNo}",
  phInHouse_Payment_Table: "Tisch",

  phInHouseLocalBasket_Table_Number: "Tisch:",
  phInHouseLocalBasket_Guest_Label: "Gast",
  phInHouseLocalBasket_User_Place: "Platz {placeNo}",
  phInHouseLocalBasket_Order_Overview: "Tischübersicht",
  phInHouseLocalBasket_Order_List_total: "Gesamt",
  phInHouseLocalBasket_Ordered_Just_Now: "Gerade eben",
  phInHouseLocalBasket_Ordered_At: "vor {min} Minuten",
  phInHouseLocalBasket_ImpressumDialog: "Impressum",
  phInHouseLocalBasket_ImpressumDialog_stnr: "St.Nr.:",
  phInHouseLocalBasket_ImpressumDialog_ustid: "USt-IdNr:",
  phInHouseLocalBasket_ImpressumDialog_commercial_register: "Handelsregister:",
  phInHouseLocalBasket_ImpressumDialog_commercial_telephone: "Telefon:",
  phInHouseLocalBasket_ImpressumDialog_local_court: "Amtsgericht:",
  phInHouseLocalBasket_ImpressumDialog_representative: "Vertretungsberechtigte Person:",

  phInHouse_Sort_Option_Added: "Bestellzeitpunkt",
  phInHouse_Sort_Option_Menucourse: "Menügang",
  phInHouse_Sort_Option_Name: "Artikelbezeichnung",
  phInHouse_Sort_Option_Price_Ascending: "Preis (aufsteigend)",
  phInHouse_Sort_Option_Price_Descending: "Preis (absteigend)",
  phInHouse_Sort_Option_Place: "Platz",

  phInHouse_Payment_Header: "Bestellübersicht",
  phInHouse_Payment_SubText: "Tisch {tableNr}",
  phInHouse_Payment_No_Assignment: "Ohne Zuordnung",

  phInHouse_Continue_Btn: "Weiter",
  phInHouse_Order_Confirm_HTML: "Ihre Bestellung auf Tischnummer {table_no} ist bei uns eingegangen und wird in Kürze zubereitet.",

  phInHouse_Item_Not_Avaliable_Header: "Artikel wird bereits bezahlt",
  phInHouse_Item_Not_Avaliable_Subtext: "Dieser Artikel wird bereits bezahlt und kann nicht erneut ausgewählt werden.",
  phInHouse_Item_Not_Avaliable_Btn: "Schließen",

  phInHouse_NoConnection_Title: "Keine Verbindung zum Restaurant",
  phInHouse_NoConnection_Description: "Aufgrund eines technischen Problems, konnte leider keine Verbindung zum Restaurant hergestellt werden. Bitte versuchen Sie es später erneut.",
  phInHouse_LostConnection_Title: "Verbindung zum Restaurant verloren",
  phInHouse_LostConnection_Description: "Die Verbindung zum Restaurant wurde leider unterbrochen. Bitte scannen Sie den Tischcode erneut.",
  phInHouse_TableClosed_Title: "Der Tisch wurde geschlossen",
  phInHouse_TableClosed_Description: "Ihr Tisch ist bereits bezahlt und wurde geschlossen. Scannen Sie bitte einen Tischcode, wenn Sie eine neue Bestellung aufgeben möchten.",
  phInHouse_Cancel_Btn: "Abbrechen",
  phInHouse_Accept_Btn: "Bestätigen",

  phInHouse_Still_There_Title: "Sind Sie noch da?",
  phInHouse_Still_There_Description: "Wir haben Ihre Artikelauswahl wegen Inaktivität zurückgesetzt, bitte wiederhole Sie Ihren Zahlungsvorgang.",

  phInHouse_ItemsInBasket_Title: "Sie haben noch Artikel in Ihrem Warenkorb",
  phInHouse_ItemsInBasket_Description: "Sie haben noch nicht bestellte Artikel in Ihren Warenkorb, möchten Sie diese verwerfen und jetzt bezahlen?",

  phInHouse_Reconnect_Dialog_Title: "Verbindung unterbrochen",
  phInHouse_Reconnect_Dialog_Info: "Die Internet Verbindung wurde unterbrochen",
  phInHouse_Reconnect_Dialog_Info_Reconnect: "Wir versuchen Sie neu zu verbinden",

  phInHouse_Discount_Title: "Kein Rabatt möglich",
  phInHouse_Discount_Info: "Ihr hinterlegter Rabatt kann in diesem Bestelltyp leider nicht verwendet werden. Bitte wenden Sie sich an unser Servicepersonal.",
  phInHouse_Voucher_Info: "Der auf Ihren Gutschein hinterlegte Rabatt kann in diesem Bestelltyp leider nicht verwendet werden. Bitte tätigen Sie die Zahlung bei unserem Servicepersonal, um Ihren Rabatt zu erhalten.",

  phInHouse_Table_Overview_Empty_Title: "Es sind noch keine Bestellungen vorhanden",
  phInHouse_Table_Overview_Empty_Desc: "Sobald etwas auf diesen Tisch bestellt wurde, können Sie hier die Tischübersicht einsehen.",

  phContinueShoppingDialog_Label: "Artikel in den Warenkorb gelegt",
  phContinueShoppingDialog_Button_Continue: "Weiter bestellen",
  phContinueShoppingDialog_Button_End: "Zum Warenkorb",

  phGroupOrder_Forward_Btn: "Weiter",
  phInHouse_UseName_Request_Title: "Bitte nennen Sie uns Ihren Namen",
  phInHouse_UseName_Request_Desc: "Bitte nennen Sie uns Ihren Namen, damit wir Ihre Tischbestellungen besser zuordnen können",
  phInHouse_UseName_Request_InputPh: "Bitte geben Sie Ihren Namen ein",

  phNotification_Dialog_Title: "Benachrichtigung",
  phNotification_Dialog_Content: "Wir benachrichtigen Sie über Ihren Browser, wenn Ihre Bestellung zur Abholung bereitsteht.",
  phNotification_Dialog_DiscardContent: "Sollten wir Sie nicht beachrichtigen dürfen, so können Sie hier Ihre Bestellung verwerfen",
  phNotification_Dialog_Annotation: "* Bitte bestätigen Sie auch die Meldung von Ihrem Browser oder Betriebssystem.",
  phNotification_Dialog_AcceptButton: "Ja, gerne",
  phNotification_Dialog_DiscardTitle: "Keine Benachrichtigung",
  phNotification_Dialog_DiscardButton: "Bestellung verwerfen",

  phNotificateVieSMS_Dialog_Title: "Entschuldigung Sie, das hat leider nicht geklappt.",
  phNotificateVieSMS_Content: "Leider hat die Aktivierung der Benachrichtigung nicht funktioniert.",
  phNotificateVieSMS_RequestContent: "Bitte tragen Sie Ihre Handynummer ein, damit wir Ihnen eine SMS schicken können, wenn Ihre Bestellung zur Abholung bereitsteht.",
  phNotificateVieSMS_AcceptButton: "Per SMS benachrichtigen",
  phNotificateVieSMS_Annotation: "*Ihre Handynummer wird ausschließlich für diese Benachrichtigung genutzt und im Anschluss wieder gelöscht.",

  phInHouse_WrongCode_Title: "Falscher Tischcode",
  phInHouse_WrongCode_Description: "Sie haben leider keinen Tischcode gescannt, bitte versuchen Sie es erneut oder wenden Sie sich an unser Servicepersonal.",
  phInHouse_WrongCode_Button: "Zurück",

  phInHouse_No_Notification: "Sie haben noch keine Benachrichtigungen aktiviert.",
  phInHouse_Push_Notification: "Wir benachrichtigen Sie, sobald Ihre Bestellung zur Abholung bereitsteht",
  phInHouse_SMS_Notification: "Wir senden Ihnen eine SMS an {phoneNumber} wenn Ihre Bestellung zur Abholung bereitsteht",
  phInHouse_SMS_Notification_Change_Number: "Nummer ändern",

  phGroupOrder_WrongCode_Title: "Falscher Gruppencode",
  phGroupOrder_WrongCode_Description: "Sie haben leider keinen Gruppencode gescannt, bitte versuchen Sie es erneut. Der Gruppencode wird allen Gruppenteilnehmern über die Funktion „Freunde einladen“ angezeigt.",
  phGroupOrder_WrongCode_Button: "Zurück",

  phGroupOrder_OrderNowDialog_Title: "Sofort bestellen",
  phGroupOrder_OrderNowDialog_Content: "Möchten Sie Ihre Bestellung wirklich sofort absenden und nicht zusammen mit Ihren Freunden bestellen?",
  phGroupOrder_OrderNowDialog_AcceptButton: "Sofort bestellen",
  phGroupOrder_OrderNowDialog_DenyButton: "Abbrechen",

  phGroupOrder_SendOrderDialog_Title: "Gruppenbestellung absenden?",
  phGroupOrder_SendOrderDialog_Description: "Sind Sie sich sicher, dass Sie die Gruppenbestellung für alle Gruppenteilnehmer jetzt aufgeben möchten?",
  phGroupOrder_SendOrderDialog_AcceptBtn: "Ja, jetzt bestellen",
  phGroupOrder_SendOrderDialog_DenyBtn: "Nein, zurück zur Gruppenansicht",

  phBasketPay_OptionDialog_Title: "Wie möchten Sie zahlen?",
  phBasketPay_OptionDialog_Description: "Bitte wählen Sie aus, ob Sie an der Kasse, oder digital per Handy bezahlen möchten.",
  phBasketPay_OptionDialog_PayWaiterBtn: "An der Kasse bezahlen",
  phBasketPay_OptionDialog_PayOnlineBtn: "Digital am Handy bezahlen",
  phBasketPay_WaiterDialog_Title: "An der Kasse bezahlen",
  phBasketPay_OptionDialog_Back_Btn: "zurück zum Tisch",
  phBasketPay_WaiterDialog_Description: "Vielen Dank für Ihre Auswahl, bitte zahlen Sie direkt an der Kasse.",
  phBasketPay_ErrorDialog_Title: "Entschuldigen Sie, leider ist ein Fehler aufgetreten",
  phBasketPay_ErrorDialog_Description: "Leider konnten wir Ihre Zahlungsanfrage nicht verarbeiten.<br>Bitte versuchen Sie es später erneut.",
  phBasketPay_ErrorDialog_Dialog_Button: "Zurück",

  phGroupOrder_Landingpage_Title: "Bestellgruppe {groupname}",
  phGroupOrder_Landingpage_Creator: "von {creator}",
  phGroupOrder_Landingpage_BasketTitle: "Aktueller Gruppenwarenkorb",
  phGroupOrder_Landingpage_EmptyBasketContent: "Keine Artikel ausgewählt",
  phGroupOrder_Landingpage_BasketContent: "Artikel im Wert von",
  phGroupOrder_Landingpage_SendGroupOrder_Btn: "Gruppenbestellung absenden",
  phGroupOrder_Landingpage_LeaveGroupOrder_Btn: "Gruppe verlassen",

  phGroupOrder_NoOrderYet_Description: "Es sind noch keine Artikel in dieser Bestellgruppe zur Zahlung vorhanden. Bitte tätigen Sie erst eine Bestellung, um diese Funktion nutzen zu können.",

  phGroupOrder_LeaveTable_Dialog_Title: "Möchten Sie die Bestellgruppe wirklich verlassen?",
  phGroupOrder_LeaveTable_Dialog_Content: "Es sind noch nicht alle Artikel bezahlt oder es befinden sich noch nicht bestellte Artikel im Gruppenwarenkorb. Möchten Sie die Bestellgruppe wirklich verlassen?",
  phGroupOrder_LeaveTable_Dialog_Button: "Gruppe verlassen",

  phGroupOrder_Button_Text: "Sie sind Mitglied der Bestellgruppe",

  phGroupOrder_Continue_Btn: "Weiter",
  phGroupOrder_Continue_to_Basket_Btn: "Bestellen",
  phGroupOrder_Create_GroupNameInput_PlaceHolder: "Neuer Gruppenname",
  phGroupOrder_Input_Validate_Length: "Bitte geben Sie mindestens 3 Buchstaben ein",
  phGroupOrder_Input_Validate_Forbbiden: "Unzulässiger Gruppenname",
  phGroupOrder_Input_Validate_Empty: "Der Gruppenname darf nicht leer sein",
  phGroupOrder_Input_Validate_Characters: "Bitte verwenden Sie keine Sonderzeichen",
  phGroupOrder_Input_Validate_Name: "Der Name darf nicht leer sein.",
  phGroupOrder_Input_Validate_Forbbiden_UserName: "Unzulässiger Name",

  phGroupOrder_CreateGroup_Header: "Neue Gruppenbestellung erstellen",
  phGroupOrder_CreateGroup_Subtext: "Bitte wählen Sie einen Namen für Ihre Gruppe aus",
  phGroupOrder_CreateGroup_Input_Info: "... oder geben Sie einen eigenen Gruppennamen an",
  phGroupOrder_CreateGroup_JoinGroup_Info: "... oder treten Sie einer bestehenden Bestellgruppe bei",
  phGroupOrder_CreateGroup_JoinGroup_Header: "Beitreten",
  phGroupOrder_CreateGroup_JoinGroup_Desc: "Hier können Sie einer bestehenden Bestellgruppe beitreten",
  phGroupOrder_CreateGroup_Failed_Title: "Erstellung der Bestellgruppe fehlgeschlagen",
  phGroupOrder_CreateGroup_Failed_SubText: "Leider kam es zu einem Fehler bei der Erstellung Ihrer Bestellgruppe, bitte versuchen Sie es in einigen Minuten erneut.",
  phGroupOrder_CreateGroup_GroupName_Failed_Title: "Gruppenname bereits in Benutzung",
  phGroupOrder_CreateGroup_UserName_Failed_Title: "Benutzername bereits in Benutzung",
  phGroupOrder_CreateGroup_Name_Failed_SubText: "Der eingegebene Name ist leider bereits in Benutzung, bitte verwenden Sie einen anderen Namen.",
  phGroupOrder_CreateGroup_Create: "Gruppe erstellen",
  phGroupOrder_CreateGroup_Join_Btn: "Beitreten",

  phGroupOrder_GroupCreated_Header: "Bestellgruppe erfolgreich erstellt!",
  phGroupOrder_GroupCreated_Info: "Sie haben die Gruppe {groupName} erfolgreich erstellt.",
  phGroupOrder_GroupCreated_State_Info: "Über das Gruppensymbol in der Titelleiste können Sie jederzeit den Status Ihrer Gruppe einsehen.",
  phGroupOrder_GroupCreated_UserName_Input_Info: "Bitte geben Sie Ihren Namen ein, damit wir Ihnen Ihre Bestellung richtig zuordnen können.",
  phGroupOrder_GroupCreated_UserName_Input_placeholder: "Ihr Name",
  phGroupOrder_GroupCreated_Invite_Friends_Info: "Laden Sie Ihre Freunde in diese Bestellgruppe ein, um eine gemeinsame Bestellung aufzugeben und Ihr Essen gemeinsam genießen zu können",
  phGroupOrder_GroupCreated_Invite_Btn: "Jetzt einladen",
  phGroupOrder_GroupCreated_Without_Invite_Btn: "Weiter ohne einladen",

  phGroupOrder_GroupMaxCount_Dialog_Title: "Leider konnte keine Bestellgruppe erstellt werden.",
  phGroupOrder_GroupMaxCount_Dialog_SubText: "Leider wurde bereits die maximale Anzahl an Bestellgruppen für diesen Tisch erreicht. Bitte verwenden Sie einen anderen Tischcode oder tätigen Sie eine Einzelbestellung.",

  phGroupOrder_InviteFriends_Dialog_Title: "Möchten Sie keine Freunde einladen?",
  phGroupOrder_InviteFriends_Dialog_SubText: "Möchten Sie jetzt wirklich bestellen, ohne vorher Ihre Freunde einzuladen?  Mit einer Gruppenbestellung bekommen Sie Ihr Essen gleichzeitig und Sie können gemeinsam genießen.",
  phGroupOrder_InviteFriends_Dialog_OrderBtn: "Bestellen",
  phGroupOrder_InviteFriends_Dialog_OrderNowBtn: "Jetzt Bestellen",
  phGroupOrder_InviteFriends_Dialog_InviteBtn: "Freunde einladen",

  phGroupOrder_LinkExpired_Title: "Die Gruppe ist leider abgelaufen",
  phGroupOrder_LinkExpired_SubText: "Diese Bestellgruppe ist leider abgelaufen, bitte erstellen Sie eine neue Gruppe oder tätigen Sie eine Einzelbestellung.",
  phGroupOrder_LinkExpired_Btn: "Neue Bestellung",

  phGroupOrder_Share_Title: "Freunde einladen",
  phGroupOrder_Share_SubText: "Laden Sie Ihre Freunde in diese Gruppe ein, um eine gemeinsame Bestellung aufgeben und gemeinsam genießen zu können",
  phGroupOrder_Share_Link_Info: "Senden Sie Ihren Freunden einen Link per Whatsapp & Co",
  phGroupOrder_Share_Link_Btn: "Link teilen",
  phGroupOrder_Share_Link_NotAvailable_Title: "Teilen fehlgeschlagen",
  phGroupOrder_Share_Link_NotAvailable_Subtext: "Leider scheint das Teilen auf Ihrem Endgerät nicht zu funktionieren. Über die Schaltfläche „Link kopieren“ können Sie die Einladung dennoch an Ihre Freunde senden, indem Sie den Link in Whatsapp & Co einfügen und versenden.",
  phGroupOrder_Share_Link_Copy_Btn: "Link kopieren",

  phGroupOrder_Invite_QRCode_Title: "Per QR-Code",
  phGroupOrder_Invite_QRCode_Info: "Lassen Sie Ihre Freunde den folgenden Gruppencode scannen, damit Sie der Bestellgruppe beitreten können",
  phGroupOrder_Invite_Btn: "QR-Code scannen",

  phGroupOrder_Invitation_Recieved_Title: "Willkommen in der Bestellgruppe {groupName} von {userName}",
  phGroupOrder_Invitation_Recieved_SubText: "Bitte geben Sie Ihren Vornamen ein, damit wir Ihre Bestellung richtig zuordnen können. ",
  phGroupOrder_Invitation_Recieved_input: "Bitte geben Sie Ihren Namen ein",
  phGroupOrder_Invitation_Recieved_Join_Btn: "Beitreten",
  phGroupOrder_Invitation_Recieved_Deny_Btn: "Ablehnen",

  phGroupOrder_QRCode_Scanner_Title: "Einer Bestellgruppe beitreten",
  phGroupOrder_QRCode_Scanner_SubText: "Bitte scannen Sie einen Gruppencode, um einer Bestellgruppe Ihrer Freunde beizutreten. Der Gruppencode wird allen Gruppenteilnehmern über die Funktion „Freunde einladen“ angezeigt.",
  phGroupOrder_QRCode_Scanner_NoCam_Info: "Sollten Sie keine Kamera haben und den Gruppencode nicht scannen können, so bitten Sie Ihre Freunde eine Gruppeneinladung per Link zu teilen",

  phGroupOrder_MaxMemberCount_Title: "Kein Beitritt möglich",
  phGroupOrder_MaxMemberCount_SubText: "Leider ist kein Beitritt mehr möglich, da die maximale Gruppengröße bereits erreicht wurde. Bitte erstellen Sie eine neue Bestellgruppe oder tätigen Sie eine Einzelbestellung.",

  phGroupOrder_LocationClosed_Title: "Kein Beitritt möglich",
  phGroupOrder_LocationClosed_SubText: "Leider ist kein Beitritt mehr möglich, wie es aussieht haben wir gerade geschlossen. Bitte beachten Sie unsere Öffnungszeiten.",

  phGroupOrder_GroupOverview_Title: "Bestellgruppe {groupName} von {groupCreatorName}",
  phGroupOrder_GroupOverview_UserList_Basket: "Im Warenkorb",
  phGroupOrder_GroupOverview_UserList_Ordered: "Bestellt",
  phGroupOrder_GroupOverview_Basket_Title: "Aktueller Gruppenwarenkorb",
  phGroupOrder_GroupOverview_Basket_Info: "Artikel im Wert von",
  phGroupOrder_GroupOverview_Basket_NoOrder_Title: "Keine Artikel ausgewählt",
  phGroupOrder_GroupOverview_Basket_PlaceGroupOrder_Btn: "Gruppenbestellung absenden",

  phGroupOrder_MemberOrder_Detail_Label: "Bestellübersicht von",
  phGroupOrder_MemberOrder_Detail_Basket_Label: "Artikel im Gruppenwarenkorb",
  phGroupOrder_MemberOrder_Detail_Ordered_Label: "Bestellte Artikel",
  phGroupOrder_MemberOrder_Detail_ApplyChange_Btn: "Änderung übernehmen",
  phGroupOrder_MemberOrder_Detail_PayNow_Btn: "Jetzt bezahlen",
  phGroupOrder_MemberOrder_Detail_Total_Label: "Gesamtsumme",
  phGroupOrder_MemberOrder_Detail_Empty_Basket: "Keine Artikel im Gruppenwarenkorb",
  phGroupOrder_MemberOrder_Detail_Empty_Order: "Keine Bestellungen vorhanden",
  phGroupOrder_MemberOrder_Detail_OrderNow_Btn: "Jetzt bestellen",
  phGroupOrder_MemberOrder_Detail_State_Preparation: "in Zubereitung",
  phGroupOrder_MemberOrder_Detail_State_Pickup: "Abholbereit",
  phGroupOrder_MemberOrder_Detail_State_PickedUp: "abgeholt",

  phGroupOrder_Basket_GroupOrder_Name: "Bestellgruppe",
  phGroupOrder_Basket_AddToGroupBasket_Btn: "Zum Gruppenwarenkorb hinzufügen",
  phGroupOrder_Basket_OrderNow_Btn: "Sofort bestellen",
  phGroupOrder_Order_Overview: "Gruppenübersicht",

  phGroupOrder_Payment_Group: "Bestellgruppe",

  phGroupOrder_Confirm_HTML: "Ihre Bestellung für Bestellgruppe {group_name} ist bei uns eingegangen und wird in Kürze zubereitet.",
  phGroupOrder_PaymentResult_GroupBtn: "Zur Gruppenübersicht",

  phGroupOrder_UserIsAlready_Member_Title: "Kein Beitritt möglich",
  phGroupOrder_UserIsAlready_Member_SubText: "Sie sind bereits Mitglied einer Bestellgruppe. Bitte gehen Sie auf „Bestellgruppe verlassen“, bevor Sie einer anderen Bestellgruppe beitreten können.",

  phPhoneInput_Min_Error: "Bitte mindestens 6 Ziffern eingeben.",
  phPhoneInput_Max_Error: "Bitte maximal 16 Ziffern eingeben.",
  phPhoneInput_NumbersOnly_Error: "Bitte nur Ziffern eintragen.",

  phChangePhoneNumber_Title: "Rufnummer bearbeiten",
  phChangePhoneNumber_SubText: "Hier können Sie Ihre für die Notification hinterlegte Rufnummer {phoneNumber} anpassen. Bitte beachten Sie, dass bereits zugestellte Notifications nicht noch einmal verschickt werden.",
  phChangePhoneNumber_Btn_Label: "Übernehmen",

  phChangePhoneNumber_Failed_Title: "Entschuldigung, leider ist ein Fehler aufgetreten",
  phChangePhoneNumber_Failed_Desc: "Leider konnten wir die Änderung Ihrer Rufnummer nicht verarbeiten, bitte versuchen Sie es in einigen Minuten erneut.",

  phCoupon_Redeem_Title: "Coupons einlösen",
  phCoupon_Redeem_Description: "Hier können Sie unsere Coupons direkt im Webshop einlösen.",
  phCoupon_Redeem_AppCoupon_Title: "Coupon auswählen",
  phCoupon_Redeem_Show_All: "Alle anzeigen",
  phCoupon_Redeem_Btn_Label: "Coupon einlösen",
  phCoupon_Redeem_Scan_Title: "Couponcode scannen",
  phCoupon_Redeem_Scan_Btn_Text: "Jetzt scannen",
  phCoupon_Redeem_Scan_Btn_Text_Cancel: "Abbrechen",
  phCoupon_Redeem_Input_Title: "Couponcode eingeben",
  phCoupon_Redeem_Input_Placeholder: "{requiredLength}- stelliger Couponcode",
  phCoupon_Redeem_Error_MinLength: "Bitte mindestens {requiredLength} Ziffern eingeben.",
  phCoupon_Redeem_Error_MaxLength: "Bitte maximal {requiredLength} Ziffern eingeben.",
  phCoupon_Redeem_Error_NumbersOnly: "Bitte nur Ziffern eintragen.",
  phCoupon_Redeem_OrderType_Not_Valid_Title: "Bestelltyp ungültig",
  phCoupon_Redeem_OrderType_Not_Valid_SubText: "Für Ihren ausgewählten Bestelltyp können leider keine Coupons eingelöst werden, bitte wählen Sie einen anderen Bestelltyp aus.",
  phCoupon_Redeem_OrderType_Not_Valid_Change_Btn: "Bestelltyp wechseln",
  phCoupon_Redeem_OrderType_Not_Valid_Cancel_Btn: "Abbrechen",
  phCoupon_Redeem_Code_Not_Valid_Title: "Coupon ungültig",
  phCoupon_Redeem_Code_Not_Valid_SubText: "Der Couponcode ist leider ungültig, oder am ausgewählten Standort nicht verfügbar. Bitte verwenden Sie einen anderen Couponcode.",
  phCoupon_Redeem_Cannt_Redeem_Code_SubText: "Der Couponcode ist leider ungültig. Bitte verwenden Sie einen anderen Couponcode.",
  phCoupon_Redeem_Product_Not_Available_Title: "Coupons nicht einlösbar ",
  phCoupon_Redeem_Product_Not_Available_SubText: "Der Couponcode ist leider aktuell nicht einlösbar. Bitte versuchen Sie es morgen erneut.",
  phCoupon_Redeem_LocationAndOrderType_Dialog_Title: "Wo möchten Sie Ihren Coupon einlösen?",
  phCoupon_Redeem_LocationAndOrderType_Dialog_Tab_location_Label: "Standorte",
  phCoupon_Redeem_LocationAndOrderType_Dialog_Tab_Location_Desc: "Bitte wählen Sie einen Standort zur Einlösung Ihres Coupons aus.",
  phCoupon_Redeem_LocationAndOrderType_Dialog_Tab_OrderType_label: "Bestelltyp",
  phCoupon_Redeem_LocationAndOrderType_Dialog_Tab_OrderType_Desc: "Wie möchten Sie den Coupon bei uns einlösen?",
  phCoupon_Redeem_LocationAndOrderType_Dialog_Tab_OrderType_Empty: "Leider kann der ausgewählte Coupon an diesem Standort nicht eingelöst werden. Bitte versuchen Sie es mit einem anderen Coupon.",
  phCoupon_Redeem_Table_Login_Required_Dialog_Title: "Tischcode benötigt",
  phCoupon_Redeem_Table_Login_Required_Dialog_Desc: "Bitte scannen Sie zuerst einen Tischcode, bevor Sie den Coupon einlösen. ",
  phCoupon_Redeem_NoLocation_Dialog_Title: "Entschuldigung",
  phCoupon_Redeem_NoLocation_Dialog_Descr: "Leider kann der ausgewählte Coupon nicht eingelöst werden. Bitte versuchen Sie es mit einem anderen Coupon.",

  phUpdate_App_Optionally_Dialog_Header: "Update verfügbar",
  phUpdate_App_Optionally_Dialog_Description: "Die neue Version {versionsNummer} ist im Shop verfügbar",
  phUpdate_App_Optionally_Dialog_Btn_Update: "Aktualisieren",

  phUpdate_App_Forced_Dialog_Header: "Update erforderlich",
  phUpdate_App_Forced_Dialog_Description: "Bitte aktualisieren Sie auf die Version {versionsNummer} um unsere App weiter nutzen zu können",
  phUpdate_App_Forced_Dialog_Btn_Update: "Aktualisieren",

  phTimeCotrolDialog_Info_Items: "Produkte außerhalb der Bestellzeit",
  phTimeCotrolDialog_Description: "Ein oder mehrere Produkte können leider nicht für die ausgewählte Zeit bestellt werden. Bitte berücksichtigen Sie die jeweils angegebenen Bestellzeiten.",
  phTimeCotrolDialog_Scheduled_info_Order_Time: "Bestellzeit bis:",
  phTimeCotrolDialog_Scheduled_info_AnotherDay_Order_Time: "Bestellzeit {fromTime} - {toTime} Uhr",
  phTimeCotrolDialog_No_Order_Possible_For_Selected_Time: "Bestellung um {time} Uhr nicht möglich",
  phTimeCotrolDialog_No_Order_Possible_For_Selected_Day: "Bestellung am ausgewählten Tag nicht möglich",
  phTimeCotrolDialog_Button_Remove_item: "Produkte entfernen",
  phTimeCotrolDialog_Button_Change_Time: "Bestellzeit ändern",

  EOF: "EOF"
};
